export class CatalogoResponse {
   httpStatus : number;
   response : {
     id : string,
     codeResponse :  string,
     response : string,
     nroTotalFilas: string,
     nroTotalPaginas: string,
     list : [
      {
         id : string,
         activoId : string,
         title :  string,
         titleShowUrl : string,
         subtitle :  string,
         authorId :  string,
         description:string,
         authorName :  string,
         publicationId : string,
         publicationName :  string,
         materialId :  string,
         materialName :  string,
         subCategoryId: string,
         subCategoryName: string,
         categoryId :  string,
         categoryName :  string,
         yearId : string,
         yearName :  string,
         price :  string,
         quantity : string,
         stock :  string,
         image :  string,
         total :  string,
         thumbnail:string,
         width: string,
         height: string,
      }]
    }
    constructor(){

    this.httpStatus =0;
    this.response = {
     id : "",
     codeResponse :  "",
     response : "",
     nroTotalFilas: "",
     nroTotalPaginas: "",
     list : [
      {
         id : "",
         activoId : "",
         title :  "",
         titleShowUrl : "",
         subtitle :  "",
         authorId :  "",
         authorName :  "",
         description:"",
         publicationId : "",
         publicationName :  "",
         materialId :  "",
         materialName :  "",
         subCategoryId: "",
         subCategoryName: "",
         categoryId :  "",
         categoryName :  "",
         yearId : "",
         yearName :  "",
         price :  "",
         quantity : "",
         stock :  "",
         image :  "",
         total :  "",
         thumbnail:"",
         width: "",
         height: "",
      }]
    }
    }

}
